import { Action, createReducer, on } from '@ngrx/store';
import * as trafficStatisticsActions from '../store/traffic-statistics.action';
import { TrafficStatisticsReducer } from '../traffic-statistics.model';

const initialState: TrafficStatisticsReducer = {
  config: {
    enable_monitoring: false,
    interface_list: [],
    enable_duration: null,
  },
  columns: {
    interface_name: '',
    ip_address: '',
    host_name: '',
    mac_address: '',
    in_data: '',
    out_data: '',
    total_data: '',
    last_seen: '',
  },
};

const reducer = createReducer(
  initialState,

  on(trafficStatisticsActions.setTrafficStatisticsConfig, (state, props) => ({
    ...state,
    config: props.trafficStatisticsConfig,
  })),

  on(trafficStatisticsActions.setTrafficStatisticsColumnSearch, (state, props) => {
    const key = Object.keys(props.columnSearch)[0];
    return {
      ...state,
      columns: {
        ...state.columns,
        [key]: Object.values(props.columnSearch)[0],
      },
    };
  }),

  on(trafficStatisticsActions.clearTrafficStatisticsColumnSearch, (state) => {
    return {
      ...state,
      columns: {
        ...initialState.columns,
      },
    };
  }),

  on(trafficStatisticsActions.clearTrafficStatistics, () => initialState)
);

export function trafficStatisticsReducer(
  state: TrafficStatisticsReducer | undefined,
  action: Action
) {
  return reducer(state, action);
}
